<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">
    <div class="no-gutters">
      <mat-card-content>
        <app-integrazione-generali></app-integrazione-generali>
        <app-integrazione-allianz></app-integrazione-allianz>
        <app-integrazione-groupama></app-integrazione-groupama>
        <app-integrazione-zurich></app-integrazione-zurich>
        <app-integrazione-reale></app-integrazione-reale>
        <app-integrazione-unipol></app-integrazione-unipol>
        <app-integrazione-itas></app-integrazione-itas>
        <app-estensioni-mappa></app-estensioni-mappa>
        <app-disabled-incaricato-accertatore></app-disabled-incaricato-accertatore>
        <app-deep-property></app-deep-property>
        <app-chat-agenzia-liquidatore-ext></app-chat-agenzia-liquidatore-ext>
      </mat-card-content>
    </div>
  </div>

  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
